// // Use $ instead of jQuery without replacing global $
(function ($) {
    $(document).ready(function () {
        if ($(".hero-banner").length > 0) {
            var bgVideo = Number(localStorage.getItem("bg_Video_Store"));
            if (bgVideo == 0) {localStorage.setItem("bg_Video_Store", "0");}
            localStorage.setItem("bg_Video_Store", ++bgVideo);
            var lastNumber = parseInt($(".hero-banner .video .link").last().attr("data-number").trim());
            
            if (bgVideo >= lastNumber) {localStorage.setItem("bg_Video_Store", "0");}
            var link = $(".hero-banner .video .link[data-number='" + bgVideo + "']").addClass("active").text();
            var href = $(location).attr('href'); href = href.slice(0, href.lastIndexOf('/'));
            
            $(".hero-banner.with-video .video video").attr("src",  href + link);
        }
    });
    $(window).on("load", function () {
        $('body .hero-banner.with-video').append('<div><style>body .hero-banner.with-video:before{max-width: 1726px; opacity: 1;}</style></div>');
        $('body .hero-banner').append('<div><style>body .hero-banner:before{opacity: 1;}</style></div>');
        setTimeout(function () {
            $(".hero-banner .video video").css("opacity", "1");
        }, 60);
    });
})(jQuery);